import { CdkTextareaAutosize } from '@angular/cdk/text-field'
import { Component, EventEmitter, Output, ViewEncapsulation, inject } from '@angular/core'
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'

import { FlxButtonComponent } from '@flowx/angular-ui-toolkit'
import { FlxFormControlModule, FlxModalModule, FlxModalService } from '@flowx/angular-ui-toolkit'

const feedbackReasons = [
  'Does not answer my request',
  'Result is wrong/inaccurate',
  'Contains irrelevant elements',
]

@Component({
  selector: 'flx-ai-feedback-modal',
  imports: [
    FlxModalModule,
    FlxFormControlModule,
    FormsModule,
    ReactiveFormsModule,
    CdkTextareaAutosize,
    FlxButtonComponent,
  ],
  templateUrl: './ai-feedback-modal.component.html',
  styleUrls: ['./ai-feedback-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AiFeedbackModalComponent {
  private modalService = inject(FlxModalService)

  @Output() dataEventEmitter = new EventEmitter<any>()

  feedbackReasons = feedbackReasons

  feedbackFG: FormGroup<{
    reason: FormControl<string>
    message: FormControl<string>
  }> = new FormGroup({
    reason: new FormControl<string>(null, [Validators.required]),
    message: new FormControl<string>('', []),
  })

  submitFeedback(): void {
    if (this.feedbackFG.invalid) {
      return
    }

    const { reason, message } = this.feedbackFG.value

    this.dataEventEmitter.emit({
      confirm: true,
      reason,
      feedback: message,
    })

    this.closeModal()
  }

  closeModal(): void {
    this.modalService.hide()
  }
}
